/**
 * validator utility for all the forms
 * @param {*} values 
 * @returns 
 */

import { matchIsValidTel } from 'mui-tel-input';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const toContactDigits = (phoneValue) => {
  if (!phoneValue) return '';
  return String(phoneValue).replace(/\D/g, '');
};

/** Convert API-stored digits into the formatted value mui-tel-input expects. */
export const toContactTelInput = (phoneValue) => {
  if (!phoneValue) return '';
  const raw = String(phoneValue).trim();
  if (raw.startsWith('+')) return raw;

  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';

  const parsed = parsePhoneNumberFromString(`+${digits}`);
  if (parsed) {
    return parsed.formatInternational();
  }
  return `+${digits}`;
};

export const getContactValidationError = (phoneValue) => {
  if (!phoneValue || !String(phoneValue).trim()) {
    return 'Mobile number is required';
  }

  const digits = toContactDigits(phoneValue);
  if (digits.length <= 3) {
    return 'Mobile number is required';
  }

  const telValue = String(phoneValue).startsWith('+') ? phoneValue : toContactTelInput(phoneValue);
  if (!matchIsValidTel(telValue)) {
    return 'Mobile no. is invalid';
  }
  return null;
};

export const validateLoginForm = (values) => {
    const errors = {};
   
     if (!values.email_id.trim()) {
       errors.email_id = 'email id required';
     }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email_id.trim())) {
       errors.email_id = 'invalid email address';
     }
   
     if (!values.password.trim()) {
       errors.password = 'password is required';
     }
   
     return errors;
};

export const validateRegisterationForm = (values) => {
  const errors = {};
  if (!values.first_name.trim()) {
    errors.first_name = 'First name is required';
  }
  if (!values.last_name.trim()) {
    errors.last_name = 'Last name is required';
  }
   if (!values.email_id.trim()) {
     errors.email_id = 'Email id required';
   }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email_id.trim())) {
     errors.email_id = 'Email address is invlaid';
   }
 
  const contactError = getContactValidationError(values.contact);
  if (contactError) {
    errors.contact = contactError;
  }

   if (!values.password.trim()) {
     errors.password = 'Please provide password';
   }

   if(!values.terms){
    errors.terms="Please accept the terms & conditons, fees & privacy policy. "
   }
 
   return errors;
 };
 
 export const validateForgotPasswordForm = (values) => {
  const errors = {};
 
   if (!values.email_id.trim()) {
     errors.email_id = 'email id required';
   }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email_id)) {
     errors.email_id = 'Invalid email address';
   }
 
   return errors;
};

export const validateResetPasswordForm = (values) => {
  const errors = {};
 
  if (!values.password.trim()) {
    errors.password = 'Please provide password';
  }
  else if (!values.confirm_password) {
    errors.confirm_password = 'Please confirm the password';
  }else{
    if(values.password!==values.confirm_password) {
      errors.confirm_password = "Password not matched";
    }
  }

   return errors;
};
